<template>
  <div>
    <unicom-tabela
      :exibirQtItensPagina="qtPaginas > 0"
      iconeMensagemVazia="search"
      mensagemVazia="Nenhum resultado encontrado"
      subtituloMensagemVazia="mostrar todos"
      mostrarNovoBlocoVazio
      alturaMinimaBody="260px"
      :alturaBody="300"
      :icones="[]"
      :itensPorPagina="['5', '10', '15', '20']"
      :itemSelecionadoProp="itemSelecionado"
      :pagina="pagina"
      :qtPaginas="qtPaginas"
      :qtResultados="qtResultados"
      :rows="rows"
      :cabecalho="cabecalhoDinamico"
      :carregamento="loadingTabela"
      textoExibindo="Resultados"
      contemHover
      @click-subtitulo-mensagem="$refs.filtro.limpar()"
      @click-linha="clickLinha"
      @troca-pagina="trocarPagina"
      @troca-elemento-pagina="trocarElementoPagina"
      @ordena="ordenarColuna"
      class="header-personalizado status-com-tooltip"
    >
      <div slot="header">
        <unicom-linha espacamento :justificarItem="'end'">
          <unicom-coluna sm="12" md="auto" class="flex-fill">
            <unicom-barra-pesquisa-v2
              v-model="campoPesquisa"
              @limpar-campos="limparCampoPesquisa"
              @pesquisar="pesquisarTabela"
              placeholder="Busque por um CNPJ, código ou nome do prestador..."
            />
          </unicom-coluna>
          <unicom-coluna
            sm="12"
            md="auto"
            :class="$breakpoint.smAndDown ? 'mt-2' : ''"
          >
            <unicom-botao
              :bloco="$breakpoint.smAndDown"
              :largura="170"
              @click="mostrarFiltro = true"
              contornado
              nomeIcone="sliders"
              estiloIcone="transform: rotate(90deg);"
            >
              FILTRAR
              <div class="quantidade-filtro" v-if="quantidadeFiltro">
                {{ quantidadeFiltro }}
              </div>
            </unicom-botao>
          </unicom-coluna>
        </unicom-linha>
      </div>
    </unicom-tabela>
    <FiltroPrestadores
      :listaTipoAtendeIntercambio="listaTipoAtendeIntercambio"
      :listaStatus="listaStatus"
      :listaUnimedOrigem="listaUnimedOrigem"
      :listaTipos="listaTipos"
      :listaAnalistas="listaAnalistas"
      :listaRedes="listaRedes"
      :listaTipoAtuacao="listaTipoAtuacao"
      :habilitarFiltroIntercambio="habilitarFiltroIntercambio"
      ref="filtro"
      v-model="mostrarFiltro"
      @unimed-limpada="limparUnimed = false"
      @limpar-filtro="limparFiltro"
      @limpar-pesquisa="limparPesquisa"
      @filtrar="filtrar"
      @filtroPuro="obj => (objetoFiltroPuro = obj)"
    />
  </div>
</template>

<script>
import PrestadoresMixin from "../PrestadoresMixin";
import FiltroPrestadores from "./FiltroPrestadores";

export default {
  mixins: [PrestadoresMixin],
  components: {
    FiltroPrestadores
  },
  computed: {
    cabecalhoDinamico() {
      if (this.habilitarFiltroIntercambio) {
        return this.cabecalhoIntercambio;
      } else {
        return this.cabecalho;
      }
    }
  }
};
</script>

<style scoped>
::v-deep
  .status-com-tooltip
  > div:nth-child(2)
  > div
  > div
  > div.container-tabela.fonte-secundaria.texto.scroll-design
  > table
  > tbody
  > tr
  > td {
  position: relative;
}
/* wrapper tooltip */
::v-deep
  .status-com-tooltip
  > div:nth-child(2)
  > div
  > div
  > div.container-tabela.fonte-secundaria.texto.scroll-design
  > table
  > tbody
  > tr
  > td
  > div:nth-child(2) {
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  z-index: 0;
}
/* tooltip status block */
::v-deep
  .status-com-tooltip
  > div:nth-child(2)
  > div
  > div
  > div.container-tabela.fonte-secundaria.texto.scroll-design
  > table
  > tbody
  > tr
  > td
  > div:nth-child(2)
  > div
  > div.outlet {
  opacity: 0;
}
/* actual tooltip */
::v-deep
  .status-com-tooltip
  > div:nth-child(2)
  > div
  > div
  > div.container-tabela.fonte-secundaria.texto.scroll-design
  > table
  > tbody
  > tr
  > td
  > div:nth-child(2)
  > div
  > div.tooltip {
  opacity: 1;
}
</style>
